export default ({
  align,
  content
}, {
  rhythm
}) => ({
  container: {
    textAlign: align
  },

  root: {
    marginTop: content && rhythm(1)
  }
})



// WEBPACK FOOTER //
// ./components/ui/Content/LayoutDefault/styles.js